module.exports = __webpack_public_path__ + "img/AP_dettaglioprodotto_368_formazione.fd25d6ab.png";